module.exports = __webpack_public_path__ + "d9a7a0775d8db3a6839a35d5c822a85a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/Sumo_0.jpg
// module id = 152
// module chunks = 0